import MicroModal from 'micromodal';

$(function ($) {
  $('.js-answer-btn').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      if ($('[name="flg_quote_answer"]').is(':checked')) {
        $('.js-quote-answer-wrap').show();
        $('.js-quote-answer-wrap input[name="title"]').prop("required", true);
        $('.js-quote-answer-wrap input[name="amount"]').prop("required", true);
        console.log('show');
      } else {
        $('.js-quote-answer-wrap').hide();
        console.log('hide');
        $('.js-quote-answer-wrap input[name="title"]').removeAttr("required");
        $('.js-quote-answer-wrap input[name="amount"]').removeAttr("required");
      }
      MicroModal.show('modal-answer', {
        awaitCloseAnimation: true,
        disableScroll: true,
      });
    }
    $('input[name="flg_quote_answer"]').on('change', function() {
      if ($(this).prop("checked") == true) {
        $('.js-quote-answer-wrap').fadeIn();
        $('.js-quote-answer-wrap input[name="title"]').prop("required", true);
        $('.js-quote-answer-wrap input[name="amount"]').prop("required", true);
      } else {
        $('.js-quote-answer-wrap').fadeOut();
        $('.js-quote-answer-wrap input[name="title"]').removeAttr("required");
        $('.js-quote-answer-wrap input[name="amount"]').removeAttr("required");
      }
    });
  });
});